module.exports = __webpack_public_path__ + "img/icon-sync-alt.68bebfaa.svg";